<template>
    <div class="withdrawal-content">
        <div class="column first">
            <div class="notice">
                {{ $t('cashInstantWithdrawalNotice1') }}
                <span style="font-weight: 500;">{{ $t('cashInstantWithdrawalNotice2') }}</span>
                {{ $t('cashInstantWithdrawalNotice3') }}
            </div>
            <div class="notice pale">
                {{ $t('Dear Customers, according to OUG 18 of March 15, 2018, as of March 24, 2018, the tax due' +
                    ' for withdrawals from online gaming accounts, amounting to 1% (for amounts up to 66750 RON) of' +
                    ' the withdrawn amount, is also determined is retained at source.') }}
            </div>
            <SubtleLink :link="{ name: routeNames.shop }">
                {{ $t('agency list') | capitalize }}
            </SubtleLink>
        </div>
        <WithdrawalTypeContainer
            :shops="shops"
            :type="type"
            class="column"
        />
    </div>
</template>

<script>
    import { WithdrawalType } from '@models/user/enums';
    import { routeNames } from '@app/router';
    import WithdrawalTypeContainer from '../components/WithdrawalTypeContainer.ts';

    export default {
        name: 'InstantWithdrawal',
        props: {
            shops: {
                type: Array,
                required: false,
                default() {
                    return [];
                }
            },
        },
        created() {
            this.type = WithdrawalType.instant;
            this.routeNames = routeNames;
        },
        components: {
            WithdrawalTypeContainer: WithdrawalTypeContainer(WithdrawalType.instant),
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/withdrawal/AccordionItems/InstantWithdrawal.vue